import { Link } from "react-router-dom";

const LOGO_SRC = "https://customer-assets-0z36b82j.emergentagent.net/job_court-booking-hub-22/artifacts/fsvri6nu_WhatsApp%20Image%202026-08-04%20at%2018.37.01.jpeg";

/**
 * BrandLogo — the same logo image, wrapped in a premium frame.
 *
 * Effects:
 *  - Circular clip so the artwork reads as a proper mark instead of a raw photo tile.
 *  - Rotating conic gradient ring (brand orange → blue → orange) that pulses on hover.
 *  - Ambient outer glow that intensifies on hover.
 *  - Small orange live-dot on the top-right for "always open" energy.
 *  - Optional wordmark next to it.
 *
 * Two visual sizes: `size="sm" | "md" | "lg"`.
 */
export function BrandLogo({
  as = "link",         // "link" | "div"
  to = "/",
  size = "md",
  showWordmark = true,
  showLiveDot = true,
  className = "",
  wordmarkClassName = "",
}) {
  const dim = size === "lg" ? 56 : size === "sm" ? 30 : 40;
  const ringPad = size === "lg" ? 3 : 2;
  const outer = dim + ringPad * 2;

  const badge = (
    <span
      className="brand-logo-mark relative inline-flex items-center justify-center rounded-full"
      style={{ width: outer, height: outer }}
    >
      {/* Rotating conic gradient ring */}
      <span
        className="brand-logo-ring absolute inset-0 rounded-full"
        aria-hidden="true"
      />
      {/* Inner dark bezel */}
      <span
        className="absolute rounded-full bg-[#0B1120]"
        style={{ inset: 1 }}
        aria-hidden="true"
      />
      {/* The actual photo */}
      <img
        src={LOGO_SRC}
        alt="HTP Sports Hub"
        width={dim}
        height={dim}
        className="relative rounded-full object-cover brand-logo-img"
        style={{ width: dim, height: dim }}
      />
      {showLiveDot && (
        <span
          className="brand-logo-live absolute rounded-full"
          style={{ width: 8, height: 8, right: -1, top: -1 }}
          aria-hidden="true"
        />
      )}
    </span>
  );

  const content = (
    <span className={`inline-flex items-center gap-3 ${className}`}>
      {badge}
      {showWordmark && (
        <span className={`brand-logo-wordmark leading-none ${wordmarkClassName}`}>
          <span className="block font-display font-black uppercase tracking-tight text-white text-sm md:text-base">
            HTP Sports Hub
          </span>
          <span className="block font-mono text-[9px] uppercase tracking-[0.3em] text-white/40 mt-0.5">
            High Performance · Training Promise
          </span>
        </span>
      )}
    </span>
  );

  if (as === "div") return <span className="inline-flex">{content}</span>;
  return (
    <Link to={to} data-testid="brand-logo" className="inline-flex">
      {content}
    </Link>
  );
}

export default BrandLogo;
